/** Link-sharing preview (Open Graph / Twitter card) text. Image stays static. */
export type SocialMeta = { title: string; description: string };

export const SOCIAL_META_KEYS = {
  title: "seo.og_title",
  description: "seo.og_description",
} as const;

export const SOCIAL_META_IMAGE = "https://welivdit.com/og-share-v6.jpg";

export const SOCIAL_META_DEFAULTS: SocialMeta = {
  title: "WeLivdIt — US Visa Interview Coaching",
  description:
    "1,500+ US student visa approvals since 2021. DS-160 strategy, mock interviews and officer-logic prep with specialists. Rated 4.7★ on Trustpilot.",
};

export function resolveSocialMeta(overrides: Record<string, string> | null | undefined): SocialMeta {
  const o = overrides ?? {};
  const title = (o[SOCIAL_META_KEYS.title] ?? "").trim();
  const description = (o[SOCIAL_META_KEYS.description] ?? "").trim();
  return {
    title: title || SOCIAL_META_DEFAULTS.title,
    description: description || SOCIAL_META_DEFAULTS.description,
  };
}
